export const LAST_APP_OPEN_KEY = "lastAppOpen";
